import request from "../utils/request"

// 验证是否为律师端
export function checkRule(userName) {
  return request({
    url: `/system/user/getUserRole?userName=${userName}`,
    method: 'get'
  })
}

// h5登录
export function login(data) {
  return request({
    url: '/login/h5',
    method: 'post',
    data
  })
}

// 验证码登录
export function verifyCode(data) {
  return request({
    url: '/login/yzm',
    method: 'post',
    data
  })
}

//齐鲁工惠登录获取token
export function tokenInfo(data) {
  return request({
    url: '/login/qlgh',
    method: 'post',
    data
  })
}

// 获取用户详细信息
// export function getInfo() {
//   return request({
//     url: '/getInfo',
//     method: 'get'
//   })
// }

// 退出方法
// export function logout() {
//   return request({
//     url: '/logout',
//     method: 'post'
//   })
// }

// 获取验证码
// export function getCodeImg() {
//   return request({
//     url: '/captchaImage',
//     method: 'get'
//   })
// }

// 发送短信验证码
export function sendSms(data) {
  return request({
    url: '/phone/sendSms',
    method: 'post',
    params: data
  })
}

// 注册点下一步
export function signNext(data) {
  return request({
    url: '/phone/signNext',
    method: 'post',
    params: data
  })
}

// 注册
export function sign(data) {
  return request({
    url: '/phone/sign',
    method: 'post',
    params: data
  })
}

// 修改密码点下一步
export function updateNext(data) {
  return request({
    url: '/phone/updateNext',
    method: 'post',
    params: data
  })
}

// 修改密码
export function update(data) {
  return request({
    url: '/phone/update',
    method: 'post',
    params: data
  })
}